import { dateFormatter, integerFormatter } from "../../gridFormatters";


export const allFilesByShares = [
    {
        "field": "share_name",
        "headerName": "Share",
        // "enableRowGroup": true
    },
    {
        "field": "collection_date",
        "sort": "desc",
        "headerName": "Collection Date",
        "filter": "agDateColumnFilter",
        // "rowGroup": true,
        // "enableRowGroup": true,
        "cellRenderer": dateFormatter,
    },
    {
        "field": "total_size",
        "headerName": "Total Size (GiB)",
        "filter": "agNumberColumnFilter",
        "type": "numericColumn",
        "cellRenderer": integerFormatter,
        "aggFunc": "sum",
        "allowedAggFuncs": [
            "sum"
        ]
    },
    {
        "field": "used",
        "type": "numericColumn",
        "headerName": "Used (GiB)",
        "filter": "agNumberColumnFilter",
        "cellRenderer": integerFormatter,
        "aggFunc": "sum",
        "allowedAggFuncs": [
            "sum"
        ]
    }
];